/*
 * Copyright (C) 2022 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react';
import formatMessage from '../../../../../format-message';

/**
 * Provide an iframe for launching an LTI tool directly from the frontend.
 * Works just like all existing usages of the LTI <iframe> element, including
 * extracting a ref of the <iframe> directly and setting things on it later.
 *
 * TODO: consider moving allow stuff here instead of having it be the
 * responsibility of the caller, need to check if RCE uses same
 * iframeAllowances() as elsewhere
 */
const ToolLaunchIframe = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement("iframe", Object.assign({
    title: formatMessage('External tool frame'),
    ref: ref,
    className: "tool_launch"
  }, props, {
    "data-lti-launch": "true"
  }));
});
export default ToolLaunchIframe;